import * as React from "react";
import { forwardRef } from "react";
const SunroofIcon = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  fillRule: "evenodd",
  viewBox: "0 0 24 25",
  fill: "currentColor",
  "aria-hidden": "true",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("path", {
  d: "M14.8 11.585a.75.75 0 0 1 .75.75v2.801a.75.75 0 0 1-.75.75H9.3a.75.75 0 0 1-.75-.75v-2.801a.75.75 0 0 1 .75-.75h5.5zm-4.75 2.801h4v-1.301h-4v1.301zM14.006 2.75a3.75 3.75 0 0 1 3.75 3.75v3.905l.61.318a.75.75 0 0 1-.61 1.362v8.41a2.25 2.25 0 0 1-2.25 2.25H8.494a2.25 2.25 0 0 1-2.25-2.25v-8.409a.75.75 0 0 1-.627-1.354l.627-.346V6.5a3.75 3.75 0 0 1 3.75-3.75h4.012zM7.744 20.496a.75.75 0 0 0 .75.75h7.012a.75.75 0 0 0 .75-.75v-2.232c-2.641 1.21-5.837 1.226-8.512-.007v2.239zm8.512-9.114c-2.692-1.058-5.82-1.121-8.512-.032v5.223c2.59 1.483 5.964 1.46 8.512.009v-5.199zM9.994 4.25a2.25 2.25 0 0 0-2.25 2.25v3.248c2.746-.953 5.8-.891 8.512.037V6.5a2.25 2.25 0 0 0-2.25-2.25H9.994z"
}));
const ForwardRef = forwardRef(SunroofIcon);
export default ForwardRef;